import { AuthStore } from '@store/auth.facade';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = async (_route, state) => {
    const router = inject(Router);
    const authStore = inject(AuthStore);

    if (!authStore.hasValidToken()) {
        authStore.clearAuth();
        return router.createUrlTree(['/login']);
    }

    const mustChangePassword = authStore.user()?.mustChangePassword;
    const isChangePasswordRoute = state.url.startsWith('/change-password');

    if (mustChangePassword && !isChangePasswordRoute) return router.createUrlTree(['/change-password']);
    if (!mustChangePassword && isChangePasswordRoute) return router.createUrlTree(['/']);

    return true;
};